import Banner from 'common/components/banner/coupon-banner';
import ReactUtils from 'common/components/utils';
import { getUserData, saveUserData } from 'common/util/storage-helper';

function mountBannerComponent(bannerData) {
  const { id, isPersistent = true } = bannerData;
  const wasClosed = getUserData()[id];

  if (isPersistent || !wasClosed) {
    const bannerElement = document.querySelector('.js-banner-wrap');
    const bannerProps = {
      closeBanner: () => {
        unmountBannerComponent({ id, isPersistent });
      },
      ...bannerData,
    };

    ReactUtils.renderIntoElement(bannerData.Component || Banner, bannerElement, bannerProps);
  }
}

function unmountBannerComponent({ id, isPersistent = true }) {
  const bannerElement = document.querySelector('.js-banner-wrap');

  if (!isPersistent) {
    saveUserData(id);
  }
  ReactUtils.unmountElementsAt($(document), bannerElement);
}

export {
  mountBannerComponent,
  unmountBannerComponent,
};
